import { useEffect, useState } from "react";

import RightTimeApi from "@/API";

import "@style/Admin.scss";
import "@style/sass/_accounting.scss";

import Enums from "@/enums";

import { toast } from "react-toastify";

import CompanyBillableItemsTab from "./CompanyBillingItemsTab";

import CompanyInvoicesTab from "./CompanyBillingInvoicesTab";

import CompanyBillingPayments from "./CompanyBillingPayments";

import CompanyTransactionHistory from "./CompanyTransactionHistory";



const CompanyBillingTab = (props) => {

  const { updateSpinner, activeTab, adminPerms, company } = props.tabData;



  const [billingData, updateBillingData] = useState(null);

  const [isAccountManager, updateIsAccountManager] = useState(false);

  const [isAccountingStaff, updateIsAccountingStaff] = useState(false);

  const [isLoading, updateIsLoading] = useState(false);

  

  // Initialize activeSubTab from URL or default to null

  function getSubTabFromUrl() {

    if (typeof window === 'undefined') return null;

    const params = new URLSearchParams(window.location.search);

    return params.get("subTab") || null;

  }

  const [activeSubTab, setActiveSubTab] = useState(getSubTabFromUrl());



  // Update URL when tab changes

  useEffect(() => {

    if (typeof window === 'undefined' || !activeTab || !isOnThisTab()) return;

    if (company) {

      checkPermissions();

      getAccountingDataAsync();

    }

  }, [activeTab]);



  useEffect(() =>{

    const params = new URLSearchParams(window.location.search);

    if (activeSubTab && activeSubTab.trim() !== "") {

      params.set("subTab", activeSubTab);

    } else {

      params.delete("subTab");

    }

    const newUrl = window.location.pathname + '?' + params.toString();

    window.history.replaceState({}, '', newUrl);

  }, [activeSubTab]);



  if (!isOnThisTab()) return null;



  function isOnThisTab() {

    return activeTab && activeTab === "companyBilling";

  }



  function getAccountingDataAsync() {

    if (company && company.id) {

      updateIsLoading(true);

      RightTimeApi.getAsync("/Company/" + company.id + "/Accounting")

        .then(resp => {

          if (resp && resp.ok && resp.jsonData) {

            updateBillingData(resp.jsonData);

          } else {

            toast.error("Failed to load billing data");

          }

        })

        .catch(err => toast.error("Error loading billing data: " + err.message))

        .finally(() => updateIsLoading(false));

    }

  }



  function checkPermissions() {

    if (company && company.permissions && company.permissions.length > 0) {

      const isAccountMgr = company.permissions.some(p =>

        p.companyId === company.id && p.permissionId === Enums.ROLE_PERMS.CompanyMenuBilling) ||

        company.permissions.some(p => p.companyId === 1 && p.permissionId === Enums.ROLE_PERMS.SystemAdmin);



      const isAccounting = isAccountMgr;



      updateIsAccountManager(isAccountMgr);

      updateIsAccountingStaff(isAccounting);

    }

  }



  return (

    <div className="tabContent accountingTab">

      <div className="accountingSidebar">
        <div className="accountingMenu">
          {isAccountManager && (
            <button type="button" data-accounting-tab="invoices" className={activeSubTab === "invoices" ? "active" : ""} onClick={() => setActiveSubTab("invoices")}>Invoices</button>
          )}
          {isAccountManager && (
            <button type="button" data-accounting-tab="payments" className={activeSubTab === "payments" ? "active" : ""} onClick={() => setActiveSubTab("payments")}>Payments</button>
          )}
          {isAccountManager && (
            <button type="button" data-accounting-tab="transactions" className={activeSubTab === "transactions" ? "active" : ""} onClick={() => setActiveSubTab("transactions")}>Transaction History</button>
          )}
          {isAccountingStaff && (
            <button type="button" data-accounting-tab="fees" className={activeSubTab === "fees" ? "active" : ""} onClick={() => setActiveSubTab("fees")}>Fees</button>
          )}
        </div>
      </div>

      <div className="accountingContent">

        {activeSubTab === "invoices" && isAccountManager && (

          <CompanyInvoicesTab tabData={props.tabData} billingData={billingData} activeSubTab={activeSubTab} updateAccountingData={getAccountingDataAsync} updateSpinner={updateSpinner} />

        )}

        {activeSubTab === "payments" && isAccountManager && (

          <CompanyBillingPayments tabData={props.tabData} billingData={billingData} activeSubTab={activeSubTab} updateAccountingData={getAccountingDataAsync} updateSpinner={updateSpinner} />

        )}

        {activeSubTab === "transactions" && isAccountManager && (

          <CompanyTransactionHistory tabData={props.tabData} billingData={billingData} activeSubTab={activeSubTab} updateAccountingData={getAccountingDataAsync} updateSpinner={updateSpinner} />

        )}

        {activeSubTab === "fees" && isAccountingStaff && (

          <CompanyBillableItemsTab tabData={props.tabData} billingData={billingData} activeSubTab={activeSubTab} updateAccountingData={getAccountingDataAsync} updateSpinner={updateSpinner}/>

        )}

        {!isAccountManager && !isAccountingStaff && (

          <div className="horizontal">

            <div className="tableWrapper factTable">

              <table>

                <tbody>

                  <tr>

                    <td className="center">

                      <span>You do not have permission to view billing information.</span>

                    </td>

                  </tr>

                </tbody>

              </table>

            </div>

          </div>

        )}

      </div>

    </div>

  );

};



export default CompanyBillingTab;

